import * as React from 'react';

import * as styles from './styles.css';

export const RealtorInfoMobileWrapper: React.FC<React.PropsWithChildren<unknown>> = props => {
  return <div className={styles['wrapper']}>{props.children}</div>;
};

RealtorInfoMobileWrapper.displayName = 'RealtorInfoMobileWrapper';
